export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md',
  onClick,
  disabled = false,
  type = 'button',
  className = ''
}) {
  
  // Base styles
  const baseStyles = 'font-semibold rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-70 active:opacity-50';
  
  // Variant styles
  const variants = {
    primary: 'bg-brand-primary text-text-primary-light hover:opacity-70',
    secondary: 'bg-gray-100 dark:bg-background-gray text-text-primary-light dark:text-white hover:opacity-70 border border-border-light dark:border-border',
    danger: 'bg-danger text-white hover:opacity-70',
    success: 'bg-success text-white hover:opacity-70',
    outline: 'border-2 border-blue-600 dark:border-blue-500 text-blue-600 dark:text-blue-500 hover:opacity-70',
  };
  
  // Size styles
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
  };
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {children}
    </button>
  );
}